import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum DuluxRoles {
    "SystemAdministrator" = "64c6e0f9-370a-4643-9b1a-3417c211f6f1",
    "HOCentral" = "99bd8c78-047a-4107-be4b-48f8caa3377e",
    "HOBlueStore" = "078be936-21a6-49f9-9a18-e2d129dcfbf0",
    "HOAID" = "4bdd99ba-ef48-417f-81d4-d223c2ff4da6",
    "NSM" = "04cbc1e7-4f73-448f-8968-7615511e93aa",
    "RM" = "50ed01dd-609d-40f9-8311-4c6d35ec2898",
    "RSM" = "a02ee53e-097c-4c2f-9421-1d36d8a141ff",
    "BlueStoreRMM" = "0fed92b3-7b66-4311-b705-6653a60d8140",
    "ASM" = "ed3b489f-0205-4014-908c-e0b5eca89bf7",
    "SO" = "c1d6d6e8-57a7-4539-a68e-40cb7af851eb",
    "BlueStoreMDO" = "48d91370-d61e-4430-90e7-bd5e13d506ac",
    "CRO" = "589a57bb-2b85-4ac2-9995-b7cec10f4a80",
    "ISDBS" = "a44c68ab-9afd-48d5-9c88-f421cad0e099",
    "RMM" = "471e6227-eb28-4b02-9768-40e95bf795bb",
    "MDO" = "67417892-b0aa-4bf1-bf30-f5c85c16b56b",
    "BlueStoreOwner" = "ce34abc3-b57c-4f86-bb83-22637bfa348b",
    "StoreManager" = "a7c3e1b2-4d58-4f6a-9c21-8e0b5d7a1f34",
    "StoreExecutive" = "b8d4f2c3-5e69-4a7b-8d32-9f1c6e8b2045",
}

export const DULUX__USER_RM__ASSIGNED_BLUE_STORES__COLUMN_ID = "d29d0d3d-9583-48e7-9b77-9617e65bdfe5" as Uuid;
export const DULUX__USER_RSM__ASSIGNED_BLUE_STORES__COLUMN_ID = "de944ce3-7385-4527-8e6b-9cf7fd866339" as Uuid;
export const DULUX__USER_BLUE_STORE_RMM__ASSIGNED_BLUE_STORES__COLUMN_ID = "7abc432c-c39e-4df8-bdad-2ef387138481" as Uuid;
export const DULUX__USER_ASM__ASSIGNED_BLUE_STORES__COLUMN_ID = "aa43f555-6cfc-473c-aa4b-e4c3d5080dbb" as Uuid;
export const DULUX__USER_SO__ASSIGNED_BLUE_STORES__COLUMN_ID = "ebd00ef1-ce06-45f5-9674-f3ec2e45920e" as Uuid;
export const DULUX__USER_BLUE_STORE_MDO__ASSIGNED_BLUE_STORES__COLUMN_ID = "50e50b67-1d75-41d3-9c4e-9ad258a41c3f" as Uuid;
export const DULUX__USER_CRO__ASSIGNED_BLUE_STORES__COLUMN_ID = "f34fcdd2-edb9-4d77-ae69-96f5b88c1e31" as Uuid;
export const DULUX__USER_ISD_BS__ASSIGNED_BLUE_STORES__COLUMN_ID = "23214154-e099-41d8-a616-17cfe9262704" as Uuid;
export const DULUX__USER_BLUE_STORE_OWNER__ASSIGNED_BLUE_STORES__COLUMN_ID = "6378f014-f160-4aa1-ad1a-13ba506ed18c" as Uuid;
export const DULUX__USER_STORE_MANAGER__ASSIGNED_BLUE_STORES__COLUMN_ID = "c9e5a3d4-6f70-4b8c-9e43-a02d7f9c3156" as Uuid;
export const DULUX__USER_STORE_EXECUTIVE__ASSIGNED_BLUE_STORES__COLUMN_ID = "d0f6b4e5-7081-4c9d-ae54-b13e80ad4267" as Uuid;

export const DULUX__USER_RMM__REGIONS__COLUMN_ID = "a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11" as Uuid;

export const DULUX__USER_MDO__STATES__COLUMN_ID = "b0eebc99-9c0b-4ef8-bb6d-6bb9bd380a12" as Uuid;

// export const DULUX__USER_HO__STAFF_CODE__COLUMN_ID = "9259a9a4-5ed9-4863-8e85-07f2a8f57942" as Uuid;

// export const DULUX__USER_RMM__STAFF_CODE__COLUMN_ID = "817b7f3a-b40f-453f-88b6-b4c2c17316ee" as Uuid;

// export const DULUX__USER_MDO__STAFF_CODE__COLUMN_ID = "fbfed460-852c-4503-9fa6-dabbb220b404" as Uuid;
